module.exports = __webpack_public_path__ + "static/media/Wormwood_Portrait.7ad76f66.png";